// Module
var code = `<div class="noDataBlock">
    <div class="noDataBlockIMG">
        <svg>
            <use xlink:href="assets/webdesktop/web-desktop-sprite.svg#{{.noDataImg}}"></use>
        </svg>
    </div>
    <div class="noDataBlockText">{{.noDataText}}</div>
</div>`;
// Exports
export default code;